import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './Section';
import './Experience.css';

export function Experience({ items }) {
  return (
    <Section id="experience" title="Experience">
      <div className="experience-list">
        {items.map((item, index) => (
          <motion.div
            key={item.id}
            initial={{ x: -20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true, margin: '-100px' }}
            className="experience-item"
          >
            <div className="experience-dot"></div>
            <h4 className="experience-role">{item.role}</h4>
            <p className="experience-company">{item.company} • {item.duration}</p>
            <p className="experience-description">{item.description}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
